import {MathUtils} from "@webfruits/toolbox/dist/utils/MathUtils";

/******************************************************************
 * Size
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class Size {

    /* ----------------------------------------------------------------
 	 * APP
 	 * --------------------------------------------------------------*/

    static get APP_WIDTH(): number {
        return window.innerWidth;
    }

    static get APP_HEIGHT(): number {
        return window.innerHeight;
    }

    /* ----------------------------------------------------------------
 	 * BREAKPOINTS
 	 * --------------------------------------------------------------*/

    static readonly BREAKPOINT_320 = 320;
    static readonly BREAKPOINT_1024 = 1024;

    /* ----------------------------------------------------------------
 	 * METHODES
 	 * --------------------------------------------------------------*/

    static calcResponsiveValue(minValue: number, maxValue: number): number {
        const widthProgress = MathUtils.calcProgressWithinValues(
            Size.BREAKPOINT_320,
            Size.BREAKPOINT_1024,
            Size.APP_WIDTH
        );
        return Math.round(widthProgress * (maxValue - minValue) + minValue);
    }

}
